export const PAGE_REVIEWS_TYPES = {
  all_reviews: 'allReviews',
  location_review: 'locationReview',
};
